import type { SaleData } from '@am3nd-org/pointcraft-types';

import { CONFIG } from 'src/environments/environment';

import { orderCheckoutFingerprint } from './order-contract';

export interface OrderPricingContext {
  taxRate: number;
  fingerprint: string;
}
const memory = new Map<string, OrderPricingContext>();
const key = (businessId: string, orderId: string) =>
  `orders-pricing:${CONFIG.environment}:${businessId}:${orderId}`;
export function rememberOrderPricing(
  businessId: string,
  orderId: string,
  sale: SaleData,
  taxRate: number
): void {
  const storageKey = key(businessId, orderId);
  const value = { taxRate, fingerprint: orderCheckoutFingerprint(sale) };
  memory.set(storageKey, value);
  try {
    localStorage.setItem(storageKey, JSON.stringify(value));
  } catch {
    // Pricing still belongs to this checkout when optional persistence is unavailable.
  }
}
export function recalledOrderPricing(
  businessId: string,
  orderId: string
): OrderPricingContext | null {
  try {
    const value =
      memory.get(key(businessId, orderId)) ??
      JSON.parse(localStorage.getItem(key(businessId, orderId)) ?? 'null');
    return value && Number.isFinite(value.taxRate) && typeof value.fingerprint === 'string'
      ? value
      : null;
  } catch {
    return memory.get(key(businessId, orderId)) ?? null;
  }
}
